import { getDefaultContentRecords as originalDefaults } from '/workspace/sites/szvtsz-vizisport/lib/default-content';
import { withAthleteProfiles } from './athlete-profiles';

export function getDefaultContentRecords() {
  return withAthleteProfiles(originalDefaults());
}
